/**
 * In-page sub-navigation for Global Admin → Admins (#1573).
 *
 * Two pill links — People (the superadmin grant table) and Operator
 * Tokens (capability-scoped credentials for tools outside the app) —
 * under a shared header on every `/admin/admins*` page. Mirrors
 * `AgentsSubNav`: `NavLink` pills, not `Tabs`, because the destinations
 * are independent routes (each mounts its own data loader and unmounts
 * on switch), so deep-linking and back/forward semantics come for free.
 *
 * "Admins" groups the two ways elevated access is held: people who are
 * superadmins, and the tokens that act in a narrow admin capacity. Both
 * sit behind `requireSuperadmin`.
 */
import { NavLink } from 'react-router-dom'
import { cn } from '@/lib/utils'

const TABS: ReadonlyArray<{ to: string; label: string }> = [
  { to: '/admin/admins', label: 'People' },
  { to: '/admin/admins/operator-tokens', label: 'Automation Tokens' },
]

export function AdminsSubNav() {
  return (
    <nav aria-label="Admins sub-navigation" className="flex flex-wrap gap-1 border-b pb-2">
      {TABS.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          // `end` so the People pill (/admin/admins) doesn't stay active
          // while on the Operator Tokens child route.
          end
          className={({ isActive }) =>
            cn(
              'text-sm px-3 py-1.5 rounded-md transition-colors',
              isActive
                ? 'bg-primary text-primary-foreground'
                : 'text-muted-foreground hover:bg-muted hover:text-foreground',
            )
          }
        >
          {t.label}
        </NavLink>
      ))}
    </nav>
  )
}
